import React, { useEffect, useState } from 'react';
import staticMasterJson from "../../src/json-data/generalinformationdata.json";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
const GeneralInformationHeader = ({ loaninfoheaders, LoanInfo, LoanExport, LoanStatus, ApprovalStatus }) => {
    const [loanHeaderDeatils, setLoanHeaderDeatils] = useState(loaninfoheaders)
    useEffect(() => {
        // console.log(loaninfoheaders);
    }, [])
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };
    const formatpercentage = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value / 100);
    };
    const formatltv = (item) => {
        let fields = item.split('/');
        if (fields.length === 1) {
            let data1 = parseFloat(fields[0].replace('%', ''));
            return data1.toFixed(3) + '%';
        } else {
            let data1 = parseFloat(fields[0].replace('%', ''));
            let data2 = parseFloat(fields[1].replace('%', ''));
            return data1.toFixed(3) + '%' + '/' + data2.toFixed(3) + '%';
        }
    }
    const extractDate = (dob) => {
        if (!dob) return '';
        const date = dob.split(' ')[0];
        return date;
    };
    const TooltipTop = ({ id, children, title }) => (
        <OverlayTrigger placement='top' overlay={<Tooltip id={id} className="custom-tooltip">{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipBottom = ({ id, children, title }) => (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id={id} className="custom-tooltip">{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipLeft = ({ id, children, title }) => (
        <OverlayTrigger placement='left' overlay={<Tooltip id={id} className="custom-tooltip">{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipRight = ({ id, children, title }) => (
        <OverlayTrigger placement='right' overlay={<Tooltip id={id} className="custom-tooltip">{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    )
    return (<>
        <div className="card m-0 mb-3">
            <div class="card-header">
                <div className='d-flex flex-row align-items-center'>
                    <div class="d-flex flex-fill me-5">
                        <div class="">
                            <h6 class="mb-0">Loan Information Validation Score :</h6>
                        </div>
                        <div class="flex-fill ms-1">
                            <div class="progress d-none">
                                <div class="progress-bar" role="progressbar" style={{ width: '15%' }} aria-valuenow="15" aria-valuemin="0" aria-valuemax="100">
                                </div>
                                <div class="progress-bar bg-success" role="progressbar" style={{ width: '30%' }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                </div>
                                <div class="progress-bar bg-info" role="progressbar" style={{ width: '40%' }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                            <div class="progress progress-lg custom-progress-3 progress-animate" role="progressbar" aria-valuenow={LoanInfo} aria-valuemin="0" aria-valuemax="aria-valuemax">
                                <div class="progress-bar" style={{ width: `${LoanInfo}%` }}>
                                    <div class="progress-bar-value">
                                        {LoanInfo} %
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="d-flex align-items-center me-5">
                        <div class="">
                            <h6 class="mb-0">Loan Status :</h6>
                        </div>
                        <div class="flex-fill ms-2">
                           {LoanStatus === "Ready For Review" ?  <i class="ri-circle-fill text-green"></i> : <i class="ri-circle-fill text-primary"></i>} <span class="" style={{ fontWeight: 'bold' }}>{LoanStatus}</span>

                        </div>
                    </div>
                    <div class="d-flex align-items-center me-0">
                        <div class="">
                            <h6 class="mb-0">Approval Status :</h6>
                        </div>
                        <div class="flex-fill ms-2">
                            <i class="ri-circle-fill text-green"></i> <span class="" style={{ fontWeight: 'bold' }}>{ApprovalStatus}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-fill"></div>
                    <div class="d-flex align-items-center flex-fill">
                        <div class="">
                            <h6 class="mb-0 me-2">Loan Export Status :</h6>
                        </div>
                        <div class="flex-fill">
                            {LoanExport ? (
                                <>
                                    <i className="ri-circle-fill text-green me-1"></i>
                                    <span style={{fontWeight:"bold"}}>100%</span>
                                </>
                            ) : (
                                <>
                                    <i className="ri-circle-fill text-grey me-1"></i>
                                    <span style={{fontWeight:"bold"}}>0%</span>
                                </>
                            )}
                            {/* <div class="progress progress-lg custom-progress-3 progress-animate" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="aria-valuemax">
                                {LoanExport ? <div class="progress-bar bg-secondary" style={{ width: '100%' }}>
                                    <div class="progress-bar-value">
                                        100%
                                    </div>
                                </div> :
                                    <div class="progress-bar bg-secondary" style={{ width: '0%' }}>
                                        <div class="progress-bar-value">
                                            0%
                                        </div>
                                    </div>
                                }
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body" style={{ padding: '5px 0px 0px 20px' }}>
                <div className='accordion-card1'>
                    <div class="accordion accordion-flush accordion-general-info" id="accordionExample">
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <div className='row general-info w-100'>
                                        {/* {loanHeaderDeatils.slice(0, 6).map(generalinformationdata => (
                                            <div className='col-sm-2'>
                                                <h6 className='text-truncate'><TooltipTop title={generalinformationdata.DN}>{generalinformationdata.DN}</TooltipTop></h6>
                                                <div class="d-flex">
                                                    <div class="text-truncate flex-fill"><TooltipBottom title={generalinformationdata.Val}>{generalinformationdata.Val}</TooltipBottom></div>
                                                    <div class=""><span className='double-check'><i class="ri-shield-check-fill"></i></span></div>
                                                </div>
                                            </div>))} */}
                                        {loanHeaderDeatils.slice(0, 6).map(generalinformationdata => (
                                            <div className='col-sm-2' key={generalinformationdata.DN}>
                                                <h6 className=''>
                                                    {/* {generalinformationdata.Val.some(valItem => valItem.IsValid) ? (
                                                        <span className='double-check'><i className="ri-circle-fill text-success"></i></span>
                                                    ):(
                                                        <span className='double-check'><i className="ri-circle-fill text-warning"></i></span>
                                                    )}   */}
                                                    <TooltipTop title={generalinformationdata.DN}>{generalinformationdata.DN}</TooltipTop>
                                                </h6>
                                                <div className="d-flex">
                                                    <div className="flex-fill">
                                                        {generalinformationdata.Val.map((valItem, index) => (
                                                            <TooltipBottom key={valItem.SN} title={(valItem.VAL == null || String(valItem.VAL).trim() === "") ? "No data available" : valItem.VAL}>


                                                                {valItem.IsValid ?

                                                                    <TooltipTop title="Validated"><span className='double-check'> <i className="ri-circle-fill"></i></span></TooltipTop>
                                                                    :
                                                                    <TooltipTop title="Data Mismatch"> <span className='double-check-gray'> <i className="ri-circle-fill"></i></span></TooltipTop>
                                                                }
                                                                {(valItem.VAL == null || String(valItem.VAL).trim() === "") ? "NA" : valItem.VAL}
                                                                {index < generalinformationdata.Val.length - 1 && <br />} {/* Add a line break between items */}
                                                            </TooltipBottom>
                                                        ))}
                                                    </div>
                                                    {/* <div>
                                                        <span className='double-check'><i className="ri-shield-check-fill"></i></span>
                                                    </div> */}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                <div class="accordion-body me-4">
                                    <div className='row general-info'>
                                        {/* {loanHeaderDeatils.slice(6, loanHeaderDeatils.length).map(generalinformationdata => (
                                            <div className='col-sm-2'>
                                                <h6 className='text-truncate'><TooltipTop title={generalinformationdata.DN}>{generalinformationdata.DN}</TooltipTop></h6>
                                                <div class="d-flex">
                                                    <div class="text-truncate flex-fill"><TooltipBottom title={generalinformationdata.Val}>{generalinformationdata.Val}</TooltipBottom></div>
                                                    <div class=""><span className='double-check'><i class="ri-shield-check-fill"></i></span></div>
                                                </div>
                                            </div>))} */}
                                        {loanHeaderDeatils.slice(6, loanHeaderDeatils.length).map(generalinformationdata => (
                                            <div className='col-sm-2' key={generalinformationdata.DN}>
                                                <h6 className=''>
                                                    {/* {generalinformationdata.Val.some(valItem => valItem.IsValid) ? (
                                                        <span className='double-check'><i className="ri-circle-fill text-success"></i></span>
                                                    ):(
                                                        <span className='double-check'><i className="ri-circle-fill text-warning"></i></span>
                                                    )}  */}
                                                    <TooltipTop title={generalinformationdata.DN}>{generalinformationdata.DN}</TooltipTop>
                                                </h6>
                                                <div className="d-flex">
                                                    <div className="flex-fill">
                                                        {generalinformationdata.Val.map((valItem, index) => (
                                                            <TooltipBottom key={valItem.SN} title={(valItem.VAL == null || String(valItem.VAL).trim() === "") ? "No data available" : valItem.VAL}>

                                                                {
                                                                    valItem.IsValid ?
                                                                        <TooltipTop title="Validated"> <span className='double-check'> <i className="ri-circle-fill"></i></span></TooltipTop>
                                                                        :
                                                                        <TooltipTop title="Data Mismatch"><span className='double-check-gray'> <i className="ri-circle-fill"></i></span></TooltipTop>
                                                                }
                                                                {(valItem.VAL == null || String(valItem.VAL).trim() === "") ? "NA" : valItem.VAL}
                                                                {index < generalinformationdata.Val.length - 1 && <br />} {/* Add a line break between items */}
                                                            </TooltipBottom>
                                                        ))}
                                                    </div>
                                                    {/* <div>
                                                        <span className='double-check'><i className="ri-shield-check-fill"></i></span>
                                                    </div> */}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default GeneralInformationHeader